import dayjs, { Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const KNOWN_FORMATS = [
  'YYYY-MM-DDTHH:mm:ss.SSS',
  'YYYY-MM-DDTHH:mm:ss',
  'YYYY-MM-DD HH:mm:ss',
  'YYYY-MM-DD',
  'DD.MM.YYYY HH:mm:ss',
  'DD.MM.YYYY HH:mm',
  'DD.MM.YYYY',
  'YYYY.MM.DD HH:mm:ss',
  'YYYY.MM.DD',
] as const;

/**
 * Парсит даты с бэка: ISO, dd.MM.yyyy[, HH:mm[:ss]], либо массив Jackson LocalDateTime.
 */
export function parseAppDate(val?: string | number | number[] | Dayjs | Date | null): Dayjs | null {
  if (val == null || val === '') return null;
  if (dayjs.isDayjs(val)) return val.isValid() ? val : null;
  if (val instanceof Date) {
    const d = dayjs(val);
    return d.isValid() ? d : null;
  }
  if (typeof val === 'number') {
    const d = dayjs(val);
    return d.isValid() ? d : null;
  }
  if (Array.isArray(val)) {
    // Jackson WRITE_DATES_AS_TIMESTAMPS: [y, m, d, h, min, s, nano]
    if (val.length >= 3) {
      const [y, m, d, h = 0, min = 0, s = 0] = val;
      const parsed = dayjs(new Date(y, m - 1, d, h, min, s));
      return parsed.isValid() ? parsed : null;
    }
    return null;
  }
  const str = String(val).trim();
  if (!str) return null;
  for (const fmt of KNOWN_FORMATS) {
    const parsed = dayjs(str, fmt, true);
    if (parsed.isValid()) return parsed;
  }
  const fallback = dayjs(str);
  return fallback.isValid() ? fallback : null;
}

export function formatAppDateTime(
  val?: string | number | number[] | Dayjs | Date | null,
  withTime: boolean = true,
  empty: string = '—',
  withSeconds: boolean = false,
): string {
  const d = parseAppDate(val);
  if (!d) {
    if (val == null || val === '') return empty;
    // уже человекочитаемая строка с бэка (dd.MM.yyyy …) — показать как есть
    const raw = String(val).trim();
    if (/^\d{2}\.\d{2}\.\d{4}/.test(raw)) return raw;
    return empty;
  }
  if (!withTime) return d.format('DD.MM.YYYY');
  return d.format(withSeconds ? 'DD.MM.YYYY HH:mm:ss' : 'DD.MM.YYYY HH:mm');
}

export function formatAppDate(
  val?: string | number | number[] | Dayjs | Date | null,
  empty: string = '—',
): string {
  return formatAppDateTime(val, false, empty);
}

/** Unix ms для сортировки; 0 если дата битая. */
export function appDateValue(
  val?: string | number | number[] | Dayjs | Date | null,
): number {
  const d = parseAppDate(val);
  return d ? d.valueOf() : 0;
}
